/* eslint-disable @typescript-eslint/no-explicit-any */
import React, { useState } from "react";
import Shell from "../../common/components/Shell/Shell";
import { Grid } from "@mui/material";
import ToDoTaskPresenter from "./ToDoTaskPresenter";
import DTOToDoTask from "./DTOToDoTask";
import { useTranslation } from "react-i18next";
import { toast } from "react-hot-toast";
import { toDoTaskService } from "../../api/services/toDoTaskService";

const ToDoTaskController = () => {
  const { t } = useTranslation();
  const [toDoTaskData, setToDoTaskData] = useState([]);
  const [textFilter] = useState([]);
  const [refreshData,setRefreshData] = useState(false);

  function callBackFunc(data: any) {
    setToDoTaskData(data);
  }

  const getToDoTaskIdForUpdate = async (id: number, status: string) => {
    const payload = {
      id:id,
      status:status
    }
    const response: any = await toDoTaskService.updateDoToTask(payload);

    if (response.response == "success") {
      setRefreshData(true);
      toast.success(t("Updated Successfully"));
      setRefreshData(false);
    }
   
  };

  return (
    <>
    <Shell>
        <Grid
          container
          style={{
            maxWidth: "auto",
            marginLeft: "7.25em",
          }}
        >
          <DTOToDoTask
            setToDoTaskDatas={callBackFunc}
            textFilter={textFilter}
            refreshData={refreshData}
          />
          <ToDoTaskPresenter
            toDoTaskData={toDoTaskData}
            setToDoTaskIdForUpdate={getToDoTaskIdForUpdate}
            trans={t}
          />
        </Grid>
      </Shell>
     
    </>
  );
};
export default ToDoTaskController;
